import React from 'react';
import Vicky from '../images/Vicky.png';
import Facebook from '../images/facebook.svg';
import Google from '../images/google-color.svg';
import Linkedin from '../images/linkedin.svg';
import Star from '../images/star.svg';


function Testimonial(){
    return(
        <div className='testimonial'>
            <h2>Testimonials from our Alumni</h2>
            <p>Don't just take our word for it, read what our students have to say about TopInterns</p>
            <div className='Suspend'>
                <a href="#">
                    <div className='testimonialCover'>
                        <div className='testimonialProfile'>
                            <img src={Vicky} alt="profile_icon" />
                            <div><p>Farah Moussa</p>
                            <p>Batch in progress</p></div>
                            <img src={Facebook} alt="facebook_icon" />
                        </div>
                        <p>As a TopInterns student, I'm very thankful 🙏 and glad 🙂 for getting accepted in this JavaScript full stack web developer program. 
                            I'm gaining a valuable experience and in demand work skills. 
                            I'm given the opportunity to be part of a professional community, and to collaborate with other team members in order to build a 
                            project and complete challenging tasks. I feel respected and my skills and experience are valued and appreciated. Everyone in the 
                            team is always available to help and answer my inquiries. Until now, I have experienced significant improvement in my knowledge and 
                            skills, and I think the best is yet to come. I would highly recommend TopInterns to anyone who wants to start a career as a 
                            JavaScript full stack web developer 👍 👍 👍 .</p>
                            <div className='starIcons'>
                                <img src={Star} alt="star_icon" />
                                <img src={Star} alt="star_icon" />
                                <img src={Star} alt="star_icon" />
                                <img src={Star} alt="star_icon" />
                                <img src={Star} alt="star_icon" />
                                <p>18th May 2021</p>
                            </div>
                    </div>
                </a>
                <a href="#">
                <div className='testimonialCover'>
                    <div className='testimonialProfile'>
                        <img src={Vicky} alt="profile_icon" />
                        <div><p>Wassim Harake</p>
                        <p>Batch in progress</p></div>
                        <img src={Facebook} alt="facebook_icon" />
                    </div>
                    <p>Great learning techniques, helpful mentors, awesome projects. TopInterns is just the perfect place 
                        to gain both professional and interpersonal skills.
                        I'm really glad that I became a part of this amazing program with a great team behind it.
                        If you're looking to become a full stack developer, then I highly recommend TopInterns as a place to start.</p>
                        <div className='starIcons'>
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <p>23rd May 2021</p>
                        </div>
                </div>
                </a>
                <a href="#">
                <div className='testimonialCover'>
                    <div className='testimonialProfile'>
                        <img src={Vicky} alt="profile_icon" />
                        <div><p>Fatimah Nasser</p>
                        <p>Batch in progess</p></div>
                        <img src={Facebook} alt="facebook_icon" />
                    </div>
                    <p>To put it simply, being part of TopInterns is an opportunity not to be missed. 
                        Thanks to TopInterns’ web development bootcamp I am able to enter the job market in confidence and great knowledge.
                         Also, during this journey I was and still surrounded by a wonderful committee, or perhaps a family. 🙂</p>
                         <div className='starIcons'>
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <p>24th May 2021</p>
                        </div>
                </div>
                </a>
                <a href="#">
                <div className='testimonialCover'>
                    <div className='testimonialProfile'>
                        <img src={Vicky} alt="profile_icon" />
                        <div><p>M Hakimi</p>
                        <p>Batch completed: 21st April 2021</p></div>
                        <p className='test'>Course Report</p>
                    </div>
                    <p>What was promised at the beginning was delivered and more. 
                        I am happy with results. Saleem making things simple and easy to understand. 
                        A great team behind the scenes 👏, they have been helping me with my journey since day one. 
                        I have completed the TopInterns Bootcamp and I am happy that I will be joining one of the big tech company for my internship.
                         Thank you TopInterns for the amazing learning journey.</p>
                         <div className='starIcons'>
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <p>25th May 2021</p>
                        </div>
                </div>
                </a>
                <a href="#">
                <div className='testimonialCover'>
                    <div className='testimonialProfile'>
                        <img src={Vicky} alt="profile_icon" />
                        <div><p>Ahmed Mohamed</p>
                        <p>Batch completed: 14th January 2021</p></div>
                        <p className='test'>Course Report</p>
                    </div>
                    <p>Topinterns gave me the opportunity to start a career as a web developer,
                         I was offered real work projects with real employees, and I would say before I found this program I was lost and not knowing where to learn 
                         the necessary fundamentals to start working as soon as possible, and Topinterns provided both, I was taught the fundamentals and offered a junior 
                         web developer position at Laimoon, and then was given an opportunity to intern at Souqalmal. The work experience was amazing, I worked with really 
                         amazing people and I have learned so much if I told my self I learned React, html, different css frameworks like tailwind and ant design, typescript 
                         and wordpress, node js in such a short amount of time I would have not believed my self! 
                        I am thankful and grateful for this opportunity and would recommend to to anyone that wants to start a career in web development but doesn’t know 
                        where to start.</p>
                        <div className='starIcons'>
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <p>22nd April 2021</p>
                        </div>
                </div>
                </a>
                <a href="#">
                <div className='testimonialCover'>
                    <div className='testimonialProfile'>
                        <img src={Vicky} alt="profile_icon" />
                        <div><p>Ali Alkelabi</p>
                        <p>Batch completed: 10th January 2021</p></div>
                        <img src={Google} alt="google_icon" />
                    </div>
                    <p>Such a wonderful experience I learned a lot, gained a new skill, knew more stuff about the business world, how to deal with clients 
                        and additionally how to be a good manager. Really fantastic and 
                        I appreciate our instructor's effort to teach us during this course, Saleem you are the best, and I thank all Laimoon's team.</p>
                        <div className='starIcons'>
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <p>a month ago</p>
                        </div>
                </div>
                </a>
                <a href="#">
                <div className='testimonialCover'>
                    <div className='testimonialProfile'>
                        <img src={Vicky} alt="profile_icon" />
                        <div><p>Basem Torky</p>
                        <p>Batch completed: 10th January 2021</p></div>
                        <img src={Google} alt="google_icon" />
                    </div>
                    <p>The instructor Mr. Saleem did a great job and I saw him every session helping novice and professional course
                         attendees unleashing their dedication and commitment for a totally new concepts.
                         This is a big lesson learned for me.</p>
                         <div className='starIcons'>
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <p>a month ago</p>
                        </div>
                </div>
                </a>
                <a href="#">
                <div className='testimonialCover'>
                    <div className='testimonialProfile'>
                        <img src={Vicky} alt="profile_icon" />
                        <div><p>Ayaz K</p>
                        <p>Batch completed: 10th January 2021</p></div>
                    </div>
                    <p>Saleem has been very patient and flexible at the same time and also very helpful and friendly throughout the course. 
                        You will feel so excited when you will host your final app in cloud. Loved that moment.</p>
                        <div className='starIcons'>
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <p>a month ago</p>
                        </div>
                </div>
                </a>
                <a href="#">
                <div className='testimonialCover'>
                    <div className='testimonialProfile'>
                        <img src={Vicky} alt="profile_icon" />
                        <div><p>Severine Pozzo</p>
                        <p>Batch completed: 14th January 2021</p></div>
                        <img src={Linkedin} alt="linkedin_icon" />
                    </div>
                    <p>Saleem is a great mentor and a great leader. I was Saleem's student when he taught Web Development at Laimoon. 
                        Three times per week he gave me and a group of students, detailed technical lessons regarding full stack development. 
                        His class was full of great knowledge regarding industry best practices. Thanks to Saleem, I was able to have a level in web 
                        development that is valuable to outside companies, 
                        I was able to build a portfolio and I was able to apply what he told me, to learn new technologies.</p>
                        <div className='starIcons'>
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <p>a month ago</p>
                        </div>
                </div>
                </a>
                <a href="#">
                <div className='testimonialCover'>
                    <div className='testimonialProfile'>
                        <img src={Vicky} alt="" />
                        <div><p>Ahmed Mohamed</p>
                        <p>Batch completed: 14th January 2021</p></div>
                        <img src={Linkedin} alt="linkedin_icon" />
                    </div>
                    <p>Saleem was more than just and a mentor to me when I took the web development course at Laimoon, 
                        he always made us feel like he was our friend, not only he is an amazing teacher, but he is also a great positive speaker and an amazing motivator. 
                        I learned how to develop full stack web applications with Saleem, and I would definitely stay in touch with him for the rest of my career!
                         Thank you Saleem for everything and I hope you achieve everything you want in life :) 
                        I would definitely recommend taking the course he teaches while it’s available.</p>
                        <div className='starIcons'>
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <img src={Star} alt="star_icon" />
                            <p>a month ago</p>
                        </div>
                </div>
                </a>
                <a href="#">
                <div className='testimonialCover'>
                    <div className='testimonialProfile'>
                        <img src={Vicky} alt="" />
                        <div><p>Mohammed Ehsan Khan</p>
                        <p>Batch completed: 14th January 2021</p></div>
                        <img src={Google} alt="google_icon" />
                    </div>
                    <p>Taking this course made it a lot easier for me to get in to coding and web development world. 
                        The course content, and the instructor Saleem Hadad made it very easy to learn and understand even though I had no previous knowledge of 
                        Computer science and coding. I would highly recommend anyone to take this course be it anyone who is a beginner or Professional in Web Development. 
                        The best part of the course was the live interactive classes to learn, study and get all doubts cleared out. 
                        Another part which made me take up the course is the internship.
                         It helps you get experience in the work field and apply all the knowledge gained in the course.</p>
                    <div className='starIcons'>
                        <img src={Star} alt="star_icon" />
                        <img src={Star} alt="star_icon" />
                        <img src={Star} alt="star_icon" />
                        <img src={Star} alt="star_icon" />
                        <img src={Star} alt="star_icon" />
                        <p>a month ago</p>
                    </div>
                </div>
                </a>
            </div>
            <div className='buttons'>
                <button className='firstbutton'>Apply now</button>
                <button>Ask a question</button>
            </div>
        </div>
    )
};

export default Testimonial;